import axios from 'axios'
import request from '../helpers/authorizateRequest'

// Yandex Tanker (fuel). Driver endpoints take the external Yandex profile id
// and the internal FleetSoft park id; the backend resolves the external park
// and keeps the Yandex session itself. Company orders read our own DB.
const ENDPOINTS = {
    driver: '/drivers/tanker',
    orders: '/tanker/orders',
}

// Refresh and change may wait for a Yandex login and the shared rate limiter
// (up to 180 s by contract), so they get their own generous timeout.
export const LONG_TIMEOUT_MS = 240000

function driverPath(action, driverId, parkId) {
    return `${ENDPOINTS.driver}/${action}/${encodeURIComponent(driverId)}/${encodeURIComponent(parkId)}`
}

export default {
    createCancelSource() {
        return axios.CancelToken.source()
    },

    isCancel(error) {
        return axios.isCancel(error)
    },

    status(driverId, parkId, cancelToken) {
        return request.get(driverPath('status', driverId, parkId), { cancelToken })
            .then(response => response.data)
    },

    refreshLimit(driverId, parkId, cancelToken) {
        return request.post(driverPath('limit/refresh', driverId, parkId), {}, { cancelToken, timeout: LONG_TIMEOUT_MS })
            .then(response => response.data)
    },

    // Writes are never cancelled: the result must reach the screen or stay unknown.
    changeLimit(driverId, parkId, body) {
        return request.put(driverPath('limit', driverId, parkId), body, { timeout: LONG_TIMEOUT_MS })
            .then(response => response.data)
    },

    driverOrders(driverId, parkId, params, cancelToken) {
        return request.get(driverPath('orders', driverId, parkId), { params, cancelToken })
            .then(response => response.data)
    },

    companyOrders(params, cancelToken) {
        return request.get(ENDPOINTS.orders, { params, cancelToken })
            .then(response => response.data)
    },
}
